import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue-demi';
import { AbSection, AbContainer, AbTitle, AbSectionLayout } from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import CardSectionAwardsGrid from './CardSectionAwardsGrid.vue';
import CardSectionAwardsSlider from './CardSectionAwardsSlider.vue';
import { TextAlign } from '../../../../types';
import { useSectionAnalytics } from '../../../../analytics';

interface CardSectionAwardsItem {
  image?: string | null;
  alt?: string | null;
  text?: string | null;
  link?: string | null;
  creative_name?: string | null;
}

interface Props {
  id?: string | null;
  title?: string | null;
  awards: CardSectionAwardsItem[];
  isSlider?: boolean | null;
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
  analytics_placement?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionAwards',
  props: {
    id: null,
    title: null,
    awards: null,
    isSlider: { type: [Boolean, null] },
    spacing: null,
    textAlign: null,
    analytics_placement: null
  },
  setup(__props: any) {

const props = __props as {
  id?: string | null;
  title?: string | null;
  awards: CardSectionAwardsItem[];
  isSlider?: boolean | null;
  spacing?: Spacing | null;
  textAlign?: TextAlign | null;
  analytics_placement?: string | null;
};



// Analytics
const sectionRef = ref<HTMLElement | null>(null);

const analyticItems = computed(() =>
  (props.awards ?? []).map((item) => ({
    destination_url: item.link ?? '',
    creative_name: item.creative_name ?? '',
  })),
);

const { trackSelectItem, trackViewActiveItem } = useSectionAnalytics(
  sectionRef,
  {
    placement: props.analytics_placement ?? '',
    items: analyticItems.value,
  },
  { mode: 'section', sectionName: 'CardSectionAwards' },
);

const handleItemClick = (index: number) => {
  trackSelectItem(index);
};

return { __sfc: true,props, sectionRef, analyticItems, trackSelectItem, trackViewActiveItem, handleItemClick, AbSection, AbContainer, AbTitle, AbSectionLayout, CardSectionAwardsGrid, CardSectionAwardsSlider }
}

})